require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./accs-aux-campus-1-0.json") })
        }
      }, "path---accs-aux-campus-1-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---accs-aux-campus-1-0!./.cache/json/accs-aux-campus-1-0.json
// module id = 313
// module chunks = 231608221292675